import { useEffect } from 'react';

const ServiceUnavailable = () => {
  useEffect(() => {
    // Animate icon on mount
    const icon = document.querySelector('.unavailable-icon');
    if (icon) {
      setTimeout(() => {
        icon.classList.add('animate');
      }, 100);
    }
  }, []);

  return (
    <div>
      {/* Background elements */}
      <div className="background"></div>
      <div className="orb orb1"></div>
      <div className="orb orb2"></div>
      
      {/* Navigation */}
      <nav id="navbar">
        <div className="nav-container">
          <div className="logo">
            <div className="logo-icon">
              <i className="fas fa-rocket"></i>
            </div>
            <span className="logo-text">Verca</span>
          </div>
        </div>
      </nav>

      {/* Unavailable Content */}
      <section className="unavailable-section">
        <div className="unavailable-card">
          <div className="unavailable-icon">
            <i className="fas fa-globe-americas"></i>
          </div>
          
          <h1 className="unavailable-title">
            Service Not Available
          </h1>
          
          <p className="unavailable-message">
            This service is not available in your country.
          </p>
        </div>
      </section>

      <style jsx>{`
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-tap-highlight-color: transparent;
        }

        html {
            scroll-behavior: smooth;
        }

        :root {
            /* Core colors */
            --bg-primary: #0A0A0F;
            --bg-secondary: #14121E;
            --bg-tertiary: #1A1825;
            
            /* Surface colors */
            --surface: rgba(255,255,255,0.03);
            --surface-light: rgba(255,255,255,0.05);
            --surface-border: rgba(255,255,255,0.08);
            
            /* Text colors */
            --text-primary: #FFFFFF;
            --text-secondary: rgba(255,255,255,0.7);
            --text-tertiary: rgba(255,255,255,0.5);
            --text-muted: rgba(255,255,255,0.6);
            
            /* Accent colors */
            --warning: #FCB045;
            --error: #FF4757;
            --primary: #6366F1;
            --success: #4CFF50;
            
            /* Gradients */
            --gradient-primary: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            --gradient-warning: linear-gradient(135deg, #FCB045, #FD7E14);
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Lato', Roboto, 'Helvetica Neue', Arial, sans-serif;
            background: var(--bg-primary);
            color: var(--text-primary);
            overflow-x: hidden;
            line-height: 1.6;
        }

        /* Background */
        .background {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, #0A0A0F 0%, #14121E 50%, #1A1825 100%);
            z-index: -2;
        }

        /* Gradient orbs */
        .orb {
            position: fixed;
            border-radius: 50%;
            opacity: 0.1;
            z-index: -1;
            pointer-events: none;
        }

        .orb1 {
            width: 600px;
            height: 600px;
            background: radial-gradient(circle at center, rgba(252, 176, 69, 0.2) 0%, transparent 70%);
            top: -200px;
            right: -200px;
        }

        .orb2 {
            width: 500px;
            height: 500px;
            background: radial-gradient(circle at center, rgba(99, 102, 241, 0.2) 0%, transparent 70%);
            bottom: -200px;
            left: -200px;
        }

        /* Navigation */
        nav {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            padding: 20px 40px;
            background: rgba(20, 18, 30, 0.95);
            border-bottom: 1px solid rgba(255,255,255,0.05);
            z-index: 1000;
        }

        .nav-container {
            max-width: 1400px;
            margin: 0 auto;
            display: flex;
            align-items: center;
        }

        .logo {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 28px;
            font-weight: 800;
            letter-spacing: -1px;
        }

        .logo-icon {
            width: 44px;
            height: 44px;
            background: var(--gradient-primary);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 16px rgba(131, 58, 180, 0.2);
        }

        .logo-icon i {
            font-size: 22px;
            color: white;
        }

        .logo-text {
            color: #FFFFFF;
        }

        /* Unavailable Section */
        .unavailable-section {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 120px 40px 60px;
        }

        .unavailable-card {
            max-width: 480px;
            width: 100%;
            background: var(--surface);
            border: 1px solid rgba(255,255,255,0.08);
            border-radius: 24px;
            padding: 56px;
            text-align: center;
            position: relative;
            overflow: hidden;
            opacity: 0;
            animation: cardFadeIn 0.6s ease-out forwards;
            animation-delay: 0.2s;
        }

        @keyframes cardFadeIn {
            to {
                opacity: 1;
                transform: translateY(0);
            }
            from {
                opacity: 0;
                transform: translateY(20px);
            }
        }

        /* Unavailable Icon */
        .unavailable-icon {
            width: 110px;
            height: 110px;
            margin: 0 auto 28px;
            background: rgba(252, 176, 69, 0.15);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            opacity: 0;
            transform: scale(0);
            transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .unavailable-icon.animate {
            opacity: 1;
            transform: scale(1);
        }

        .unavailable-icon::before {
            content: '';
            position: absolute;
            inset: -2px;
            border-radius: 50%;
            background: var(--gradient-warning);
            opacity: 0.2;
            animation: pulse 2s infinite;
        }

        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
                opacity: 0.2;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.1;
            }
        }

        .unavailable-icon > i {
            font-size: 48px;
            color: var(--warning);
            position: relative;
            z-index: 1;
        }

        .icon-overlay {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 36px;
            height: 36px;
            background: var(--error);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 3px solid var(--bg-secondary);
        }

        .icon-overlay i {
            font-size: 20px;
            color: white;
        }

        /* Typography */
        .unavailable-title {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 20px;
            letter-spacing: -0.5px;
            line-height: 1.2;
            color: var(--text-primary);
        }

        .unavailable-message {
            font-size: 18px;
            color: var(--text-secondary);
            line-height: 1.6;
            letter-spacing: 0.3px;
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
            nav {
                padding: 16px 24px;
            }

            .unavailable-section {
                padding: 100px 24px 40px;
            }

            .unavailable-card {
                padding: 48px 32px;
            }

            .unavailable-icon {
                width: 100px;
                height: 100px;
            }

            .unavailable-icon > i {
                font-size: 42px;
            }

            .unavailable-title {
                font-size: 28px;
            }

            .unavailable-message {
                font-size: 16px;
            }
        }

        @media (max-width: 480px) {
            .unavailable-card {
                padding: 40px 24px;
                border-radius: 20px;
            }

            .unavailable-title {
                font-size: 24px;
            }

            .unavailable-message {
                font-size: 15px;
            }
        }
      `}</style>
      
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />
    </div>
  );
};

export default ServiceUnavailable;